import { useParams, Link, useNavigate } from 'react-router-dom';
import { getRecommendations, getMoodLabel } from '../utils/getRecommendations';
import FoodCard from '../components/FoodCard';
import SEO from '../components/SEO';

function Recommendation() {
  const { mood } = useParams();
  const navigate = useNavigate();
  const recommendations = getRecommendations(mood);
  const moodLabel = getMoodLabel(mood);

  if (!recommendations || recommendations.length === 0) {
    return (
      <div className="text-center py-16">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">
          Mood not found
        </h1>
        <Link to="/" className="text-gray-600 hover:text-gray-800 underline">
          Back to Home
        </Link>
      </div>
    );
  }

  return (
    <div>
      <SEO 
        title={`${moodLabel} – Food Recommendations | Mood Food Recommender`} 
        description={`Get food recommendations for when you feel ${mood}. Discover what to eat based on your mood.`} 
      />
      <div className="text-center mb-8">
        <div className="text-5xl mb-4">{moodLabel.split(' ')[0]}</div>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">{moodLabel}</h1>
        <p className="text-gray-600">
          Here are a few foods that might fit how you feel right now.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-4 mb-8">
        {recommendations.map((food, index) => (
          <FoodCard key={index} food={food} />
        ))}
      </div>

      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/" className="bg-black text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-800 transition text-center">
          ← Back to Home
        </Link>
        <button
          onClick={() => navigate('/')}
          className="bg-white border border-gray-300 text-gray-800 px-6 py-3 rounded-lg font-medium hover:bg-gray-50 transition text-center"
        >
          Try Another Mood
        </button>
      </div>
    </div>
  );
}

export default Recommendation;
